import { createRouter, createWebHistory } from "vue-router";

const routes = [
  {
    path: "/",
    name: "home",
    component: () => import("@/views/Home/index.vue"),
  },
  {
    path: "/game",
    name: "game",
    component: () => import("@/views/Game/index.vue"),
  },
  {
    path: "/game/game-details",
    name: "game-details",
    component: () => import("@/views/Game/game-details.vue"),
  },
  {
    path: "/about_us",
    name: "about_us",
    component: () => import("@/views/About/index.vue"),
  },
  {
    path: "/contact_us",
    name: "contact_us",
    component: () => import("@/views/Contact/index.vue"),
  },
  {
    path: "/order",
    name: "order",
    component: () => import("@/views/Order/index.vue"),
  },
  {
    path: "/order/detail/:id",
    name: "order-detail",
    component: () => import("@/views/Order/detail.vue"),
  },
  {
    path: "/game-coins",
    name: "game-coins",
    component: () => import("@/views/Account/game-coins.vue"),
  },
  {
    path: "/policy",
    name: "policy",
    component: () => import("@/views/policy.vue"),
  },
  {
    path: "/terms",
    name: "terms",
    component: () => import("@/views/terms.vue"),
  },
  {
    path: "/refund",
    name: "refund",
    component: () => import("@/views/refund.vue"),
  },
  {
    path: "/cookie-policy",
    name: "cookie-policy",
    component: () => import("@/views/cookie-policy.vue"),
  },
  {
    path: "/topup-payment-policy",
    name: "topup-payment-policy",
    component: () => import("@/views/topup-payment-policy.vue"),
  },
  {
    path: "/:catchAll(.*)",
    name: "NotFound",
    component: () => import("@/views/404.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    return {
      left: 0,
      top: 0,
    };
  },
});

export default router;
